import { InjectionToken, Type } from '@angular/core';
import { Provider } from '@angular/core';
import { DefaultAgentCardsService } from '../services/default-agent-service';

export const CONVERSATION_AI_TOKEN = new InjectionToken<DefaultAgentCardsService>('Conversation Ai Service');

// my-service.provider.ts
export function provideAgentCardService(serviceImplementation: Type<DefaultAgentCardsService>): Provider[] {
  return [
    {
      provide: CONVERSATION_AI_TOKEN,
      useExisting: serviceImplementation,
    },
  ];
}
